import { useEffect, useState } from "react";
import BackToTop from "./BackToTop";
import Footer from "./Footer";
import videos from "./data/videos.json";
import brandingBlocks from "./data/brandingBlocks.json";
import partners from "./data/partners.json";

const VideoSlider = ({ videos = [] }) => {
  const [index, setIndex] = useState(0);

  const prev = () => setIndex((i) => (i - 1 + videos.length) % videos.length);
  const next = () => setIndex((i) => (i + 1) % videos.length);
  const goTo = (i) => setIndex(i);

  return (
    <div className="video-slider" aria-roledescription="carousel">
      <div className="slides">
        {videos.map((v, i) => (
          <div
            key={v.id}
            className={`slide ${i === index ? "is-active" : ""}`}
            aria-hidden={i !== index}
          >
            <div className="video-frame">
              <div className="video-header">
                <h3>{v.title}</h3>
              </div>
              {i === index ? (
                <iframe
                  key={v.id}
                  title={v.title}
                  src={v.link}
                  allow="autoplay; encrypted-media; fullscreen"
                  frameBorder="0"
                  allowFullScreen
                />
              ) : null}
            </div>
          </div>
        ))}
      </div>

      <div className="slider-controls">
        <button
          type="button"
          className="prev"
          onClick={prev}
          aria-label="Previous"
        >
          <i className="fa-solid fa-chevron-left" aria-hidden="true" />
        </button>
        <button type="button" className="next" onClick={next} aria-label="Next">
          <i className="fa-solid fa-chevron-right" aria-hidden="true" />
        </button>
      </div>

      <div className="slider-dots" role="tablist" aria-label="Slides">
        {videos.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === index ? "is-active" : ""}`}
            onClick={() => goTo(i)}
            aria-selected={i === index}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

const Work = ({ path = "/work" }) => {
  useEffect(() => {
    const search = path.includes("?") ? path.split("?")[1] : "";
    const params = new URLSearchParams(search);
    const section = params.get("section");

    if (section) {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [path]);

  return (
    <div>
      <main id="work">
        {/* <section id="branding" className="branding page-section">
          <div className="work-heading" data-reveal>
            <p className="section-label">Branding</p>
            <h2>
              Brand systems
              <br />
              <span>Rebranding work</span>
            </h2>
          </div>
          <div className="work-detail" data-reveal>
            <p>
              Visual branding projects built to live across digital and physical
              touchpoints. These examples show the brand name centered on rich
              image backgrounds, with the type of work marked in the corner.
            </p>
          </div>

          <div className="branding-grid" data-reveal>
            {brandingBlocks.map((block) => (
              <a
                key={block.id}
                className="branding-card"
                href={block.link}
                target="_blank"
                rel="noreferrer noopener"
                style={{ backgroundImage: `url(${block.image})` }}
              >
                <div className="branding-card-overlay" aria-hidden="true" />
                <span className="branding-card-label">{block.label}</span>
                <div className="branding-card-content">
                  <h3>{block.title}</h3>
                </div>
              </a>
            ))}
          </div>
        </section> */}

        <section id="motion" className="our-work page-section">
          <div className="work-heading" data-reveal>
            <p className="section-label">Our work</p>
            <h2>
              Motion video projects
              <br />
              <span>Our motion projects</span>
            </h2>
          </div>
          <div className="work-detail" data-reveal>
            <p>
              A curated selection of our motion videos showcasing motion design,
              animation, and production. These motion projects follow the
              branding showcase above.
            </p>
          </div>

          <div data-reveal>
            <VideoSlider videos={videos} />
          </div>
        </section>

        {/* <section
          className="partners-section page-section"
          aria-labelledby="partners-title"
          id="partners"
        >
          <div className="partners-intro" data-reveal>
            <p className="section-label">Partners</p>
            <h2 id="partners-title">Our partners in success</h2>
            <p>
              We build with teams that value clarity, craft, and momentum. These
              partnerships reflect the trust we’ve earned through thoughtful
              creative execution.
            </p>
          </div>

          <div className="partners-marquee" data-reveal>
            <div className="partners-track">
              {[...partners, ...partners].map((partner, index) => (
                <button
                  key={`${partner.id}-${index}`}
                  className="partner-card"
                  aria-label={partner.name}
                >
                  <img src={partner.logo} alt={partner.name} />
                </button>
              ))}
            </div>
          </div>
        </section> */}
      </main>

      <Footer backLinkHref="#/" backLinkText="Back to home" />
      <BackToTop href="#work" label="Back to top" />
    </div>
  );
};

export default Work;
